import { render, staticRenderFns } from "./VatPayableReport.vue?vue&type=template&id=7053d766&"
import script from "./VatPayableReport.vue?vue&type=script&lang=js&"
export * from "./VatPayableReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports